import { defaultTheme } from '@3plearning/react-components';

export default {
  ...defaultTheme.layout,
  borderRadius: '6px',
  spacing: 8
};
